import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AppSuggestions from './AppSuggestions';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {(window.location.pathname.includes("suggestion"))
      ? <AppSuggestions />
      : <App />
    }
  </React.StrictMode>
);

